module.exports = __webpack_public_path__ + "static/media/15319367_1293506470670772_1200228264_n.e4ecfa1d.jpg";